import { render, staticRenderFns } from "./PaddockNearest.vue?vue&type=template&id=274b3f08"
import script from "./PaddockNearest.vue?vue&type=script&lang=js"
export * from "./PaddockNearest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Heading: require('/home/runner/work/platform/platform/packages/client/src/components/elements/typography/heading/Heading.vue').default,MapIcon: require('/home/runner/work/platform/platform/packages/client/src/components/elements/geo/map/marker/MapIcon.vue').default,Link: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/link/Link.vue').default,ListLink: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/list-link/ListLink.vue').default})
